import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

export const SwarmPreviewSchema = z.object({
	id: z.string(),
	profile_info: z.object({
		id: z.string(),
		full_name: z.string(),
		headline: z.string(),
		about: z.string(),
		current_location: z.string(),
		linkedin_url: z.string(),
		current_title: z.string(),
		current_function: z.string(),
		current_seniority: z.array(z.string()),
		current_company_id: z.string(),
		current_company_name: z.string(),
		current_company_website: z.string(),
		current_company_size: z.object({
			min: z.number().optional(),
			max: z.number().optional(),
		}),
		current_company_industry: z.string().optional(),
		current_company_location: z.string().optional(),
		current_company_linkedin_url: z.string().optional(),
		experience: z.array(
			z.object({
				is_current: z.boolean(),
				company_id: z.string(),
				company: z.object({
					id: z.string(),
					canonical_name: z.string(),
					name: z.string(),
					founded: z.string(),
					industry: z.string(),
					website: z.string(),
					size: z.object({
						min: z.number().optional(),
						max: z.number().optional(),
					}),
					social_media: z.array(
						z.object({
							id: z.string().optional(),
							network: z.string().optional(),
							url: z.string().optional(),
						})
					),
					locations: z.array(
						z.object({
							name: z.string(),
							city: z.string(),
							state: z.string(),
							country: z.string(),
							street_address: z.string(),
							postal_code: z.string(),
							headquarter: z.boolean(),
						})
					),
				}),
				title: z.string(),
				seniority: z.array(z.string()),
				function: z.string(),
				location: z.array(z.string()),
				start_date: z.string(),
				end_date: z.string().optional(),
				status: z.string(),
			})
		),

		education: z.array(
			z.object({
				school: z.object({
					name: z.string(),
					location: z.object({
						name: z.string(),
					}),
					website: z.string(),
					linkedin_url: z.string(),
					linkedin_id: z.string(),
				}),
				degrees: z.array(z.string()),
				majors: z.array(z.string()),
			})
		),
		social_media: z.array(
			z.object({
				connections: z.number(),
				followers: z.number(),
				id: z.string(),
				network: z.string(),
				url: z.string(),
				url_status: z.string(),
			})
		),
		smart_tags: z.array(z.string()),
		latest_role_change_at: z.string(),
		current_job_updated_at: z.string(),
		updated_at: z.string(),
		created_at: z.string(),
		last_refresh_at: z.string(),
	}),
});

export const SwarmPreviewResponseSchema = z.object({
	data: z.array(SwarmPreviewSchema),
	totalCount: z.number(),
});

export type SwarmPreview = z.infer<typeof SwarmPreviewSchema>;
export type SwarmPreviewResponse = z.infer<typeof SwarmPreviewResponseSchema>;
